import { api } from 'app/config/apiConfig';

export const syncLeadAdsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    syncLeadAds: builder.mutation<void, void>({
      query: () => ({
        url: '/leads/ads/sync',
        method: 'POST',
      }),
    }),
  }),
});

export const { useSyncLeadAdsMutation } = syncLeadAdsApi;
